

export default function MassiveText(props) {


    return (
        <div>
            <div className="custom-font font-bold" style={{
                fontSize: '20vw',
                lineHeight: '18vw',
            }}>
                CREATIVE CONTENT
            </div>
            <div className="custom-font font-bold" style={{
                fontSize: '20vw',
                lineHeight: '18vw',
            }}>
                AND DIGITAL
                <span className="w-20 text-5xl"><button className="bg-red-600 py-4 px-10 rounded">Get in Touch</button></span>
                {" "}SOLUTIONS
            </div>
        </div>
    )
}